import { NAVIGATION_KEYS } from '../constants/navigationKeys';

/**
 * Whether a keypress should reach a `NumberInput`. Digits, navigation and
 * editing keys, and anything held with a modifier (so Ctrl/Cmd+V still pastes);
 * everything else is dropped.
 *
 * A mask's own separators are never typed - the formatter inserts them - so
 * blocking them here is safe for every mask.
 */
export const isAllowedNumericKey = (event: {
  ctrlKey: boolean;
  key: string;
  metaKey: boolean;
}): boolean => {
  if (event.ctrlKey || event.metaKey || NAVIGATION_KEYS.includes(event.key)) {
    return true;
  }

  return /^\d$/.test(event.key);
};
